import { clsx } from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

export type InputGroupProps = ComponentPropsWithoutRef<'div'> & {
    disabled?: boolean;
    inputState: 'normal' | 'valid' | 'invalid';
};

const InputGroup = ({ disabled, inputState, children, className, ...props }: InputGroupProps) => (
    <div
        {...props}
        data-disabled={disabled}
        data-state={inputState}
        className={clsx(
            className,
            // layout
            'relative flex w-full items-center',
            // base box
            'rounded-md bg-white px-3 outline-1 outline-neutral-300',
            // focus
            'focus-within:outline-2 focus-within:outline-teal-500',
            // invalid state
            'data-[state=invalid]:text-red-500 data-[state=invalid]:outline-red-300',
            // validate state
            'data-[state=valid]:text-green-500 data-[state=valid]:outline-green-300',
            // disable state
            'data-[disabled=true]:bg-neutral-50 data-[disabled=true]:text-neutral-500'
        )}
    >
        {children}
    </div>
);

export default InputGroup;
